export function normalizeUrl(url: URL, ignoreQueryParams: boolean): string {
  const u = new URL(url.toString());
  u.hash = "";
  if (ignoreQueryParams) u.search = "";
  return u.toString();
}
